import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicInsuranceService {
  constructor(private http: PublicHttpClientService) {}

  public getInsuranceRenewalData(account_id): Observable<any> {
    return this.http
      .get("/api/public/insurance_renewal_processes/" + account_id + "/details")
      .pipe(tap((_) => console.log("PublicInsuranceService.getInsuranceRenewalData: Ok.")));
  }

  public trackMail(insurance_id: string) {
    return this.http
      .post("/api/public/insurance_renewal_processes/" + insurance_id + "/track_mail", {})
      .pipe(tap((_) => console.log("PublicInsuranceService.trackMail: Ok.")));
  }

  public sendVerificationCode(insurance_id: string, params: any): Observable<any> {
    return this.http
      .post("/api/public/insurance_renewal_processes/" + insurance_id + "/send_token", params)
      .pipe(tap((_) => console.log("PublicInsuranceService.sendVerificationCode: Ok.")));
  }

  public verifyVerificationCode(insurance_id: string, params) {
    return this.http
      .post("/api/public/insurance_renewal_processes/" + insurance_id + "/confirm_code", params)
      .pipe(tap((_) => console.log("PublicInsuranceService.verifyVerificationCode: Ok.")));
  }

  public getOrdasInsurers(): Observable<any> {
    return this.http
      .get("/api/public/insurance/insurers")
      .pipe(tap((_) => console.log("InsuranceService.getOrdasInsurers: Ok.")));
  }
}
